import UnauthenticatedLayout from "@/Layouts/UnauthenticatedLayout";
import { formatDate } from "@/lib/utils";
import type { UnauthenticatedPageProps } from "@/types";
import type { Article } from "@/types/app/Article";
import type { PaginatedResult } from "@/types/app/PaginatedResult";
import { router } from "@inertiajs/react";
import {
	Alert,
	Button,
	Card,
	CardBody,
	Divider,
	Link,
	Pagination,
} from "@nextui-org/react";

type ArticlesPageProps = {
	articles: PaginatedResult<Article>;
};

export default function ArticlesPage({
	articles,
	ziggy,
	app,
}: UnauthenticatedPageProps<ArticlesPageProps>) {
	return (
		<UnauthenticatedLayout ziggy={ziggy} app={app} title="Aktuality">
			{articles?.data?.length > 0 ? (
				<>
					{articles.data.map((article) => (
						<Card
							key={article.id}
							className="w-full md:w-3/4 mx-auto border-none bg-background/60 "
						>
							<CardBody className="flex md:flex-row flex-col gap-4">
								<div className="text-sm">
									{formatDate(article.created_at as string, true)}
								</div>
								<div className="flex flex-col gap-2 w-full">
									<h3 className="font-bold uppercase text-lg">
										{article.header}
									</h3>
									{/* biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation> */}
									<div dangerouslySetInnerHTML={{ __html: article.text }} />
									{article.files && article.files.length > 0 ? (
										<>
											<Divider className="w-full" />
											<div className="flex flex-col gap-1">
												<p>Přílohy:</p>
												{article.files.map((attachment) => (
													<Button
														key={attachment.id}
														href={attachment.filepath}
														as={Link}
														target="_blank"
														rel="noreferrer"
														variant="solid"
														size="sm"
														showAnchorIcon
														className="w-fit"
													>
														{attachment.name}
													</Button>
												))}
											</div>
										</>
									) : undefined}
								</div>
							</CardBody>
						</Card>
					))}
					<Pagination
						className="mx-auto"
						showControls
						page={articles.current_page}
						total={articles.last_page}
						onChange={(e) => router.get(`/articles?page=${e}`)}
					/>
				</>
			) : (
				<div className="flex items-center justify-center md:w-1/2 w-full mx-auto">
					<Alert title="Nebyla nalezena žádná aktualita" />
				</div>
			)}
		</UnauthenticatedLayout>
	);
}
